import { useCallback, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import {
  L4_SEGMENTATION_TABS,
  mergeL4SegmentationUrlParams,
  parseL4SegmentationUrl,
} from 'lib/l4_segmentation/urlSearchParams';

function useL4SegmentationUrlParams() {
  const history = useHistory();
  const location = useLocation();

  const params = useMemo(() => parseL4SegmentationUrl(location.search), [location.search]);

  const replaceParams = useCallback(
    patch => {
      const search = mergeL4SegmentationUrlParams(location.search, patch);
      if (search === location.search) return;
      history.replace({ pathname: location.pathname, search });
    },
    [history, location.pathname, location.search],
  );

  useEffect(() => {
    const qp = new URLSearchParams(location.search || '');
    const tabRaw = qp.get('tab');
    if (tabRaw != null && tabRaw !== '' && !Object.values(L4_SEGMENTATION_TABS).includes(tabRaw)) {
      replaceParams({ tab: null });
    }
  }, [location.search, replaceParams]);

  return { params, replaceParams };
}

export default useL4SegmentationUrlParams;
